<div class="forbidden-container">
    <h1>403 Forbidden</h1>
    <p>You don’t have permission to access this resource.</p>
    <!-- <p>Error Code: <strong>403</strong></p> -->
    <a (click)="goBackToHome()" class="back-home cursor-pointer">Go back to Home</a>
  </div>
  